export default __webpack_public_path__ + "static/media/metaValidate.2f04dbdf.svg";